/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.223.0-v202611042211-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

/**
 * Arguments for the FormulaCreator feature
 */
export interface DerivedFeatureV1 {
    /**
     * Stable identifier for a feature that persists across template versions
     */
    "canonicalId"?: string;
    /**
     * Description of the feature
     */
    "description"?: string;
    /**
     * Feature ID; omit on create
     */
    "id"?: string;
    /**
     * Indicates if this feature is an output
     */
    "isOutput"?: boolean;
    /**
     * Name of the feature
     */
    "name": string;
    /**
     * Item-type-specific metadata describing the compiled output. Currently only the unit of measure is captured: Signal uses the Value Unit Of Measure key and Scalar uses the Unit Of Measure key; an absent key indicates the Any-UOM opt-out and an empty-string value indicates the dimensionless unit. Structured as an extensible map so additional item-type-specific properties can be added without a schema change.
     */
    "outputItemMetadata"?: { [key: string]: string; };
    /**
     * The resolved output item type from formula compilation (e.g., Signal, Scalar, Condition).
     */
    "outputItemType"?: string;
    /**
     * Type of the feature output
     */
    "outputType": OutputTypeEnum;
    /**
     * The list of rules that determine the resulting value of a feature. At least one rule is required
     */
    "rules": Array<models.FeatureRuleV1>;
}

export const OutputTypeEnum = {
    TEXT: 'TEXT',
    NUMERIC: 'NUMERIC',
    ITEMID: 'ITEM_ID',
    BOOLEAN: 'BOOLEAN'
} as const;

export type OutputTypeEnum = typeof OutputTypeEnum[keyof typeof OutputTypeEnum];
